import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
import { Info, Edit, ArrowForwardIos } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { fetchDSBatchDetails } from "../../../containers/actions/common/saslAction";

import {
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

import { appUrl } from "../../../../../utils/config";
import { PDFViewer } from "../sasl/batch/updateBatch/StructuredInformation/PDFViewer";

// API data structure - this comes directly from your API

const initialApiData = {
  "patheon_batch": {
      "value": "CPLJN",
      "confidence": "99.970703125"
  },
  "manufacture_date": {
      "value": "14.Jun.2024",
      "confidence": "98.85184478759766"
  },
  "expiry_date": {
      "value": "MAY 2027",
      "confidence": "99.6630859375"
  },
  "fill_before_date": {
      "value": "N/A",
      "confidence": "100.0"
  },
  "material_number": {
      "value": "50066009",
      "confidence": "99.970703125"
  },
  "product_name": {
      "value": "Entecavir Tab 0.5 mg Bulk Drum PATH(SFG)",
      "confidence": "99.29097747802734"
  },
  "material_information": [
      {
          "api_code_1": {
              "value": "1800006232",
              "confidence": "97.19374084472656"
          },
          "consumed_bms_batch_1": {
              "value": "1116977",
              "confidence": "97.19374084472656"
          },
          "consumed_patheon_batch_1": {
              "value": "CPo126416-14-06-07",
              "confidence": "97.19374084472656"
          },
         
          "actual_consumed_batch_quantity_1": {
              "value": null,
              "confidence": 0
          },
          "consumed_material_uom_1": {
              "value": null,
              "confidence": 0
          }
      },
      {
          "api_code_2": {
              "value": "1800006232",
              "confidence": "96.21317291259766"
          },
          "consumed_bms_batch_2": {
              "value": "1119368",
              "confidence": "96.21317291259766"
          },
          "consumed_patheon_batch_2": {
              "value": "CPo126416-13-06-01",
              "confidence": "96.21317291259766"
          },
          "actual_consumed_batch_quantity_2": {
              "value": null,
              "confidence": 0
          },
          "consumed_material_uom_2": {
              "value": null,
              "confidence": 0
          }
      }
  ],
  "qty_produced": {
      "value": "1270 TH",
      "confidence": "99.814453125"
  },
  "total_weight": {
      "value": "1270",
      "confidence": "99.814453125"
  },
  "uom": {
      "value": "TH",
      "confidence": "99.814453125"
  },
  "number_of_containers": {
      "value": null,
      "confidence": 0,
      "needValidation": true
  },
  "container_type": {
      "value": null,
      "confidence": 0,
      "needValidation": true
  },
  "document_type": "CertificateOfManufacture",
  "folder_name": "Patheon",
  "site_name": "Toronto",
  "filename": "Patheon-Toronto-CertificateOfManufacture-4500023986-CPLJN.pdf",
  "s3_location": "s3://bms-processed-files/Patheon/Toronto/4500023986-CPLJN/Patheon-Toronto-CertificateOfManufacture-4500023986-CPLJN.pdf"
}
// styling
const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

function ManufactureCertificate(props) {
  const { initialData, onClose, schrockenCustomFileID, digitizedData, batchDetails, poNumber, batchNumber, onDataRefresh } = props;
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState(initialData || {});
  const [originalData, setOriginalData] = useState(initialData || {});
  const [editedData, setEditedData] = useState(initialData || {});
  const [apiDigitalizationCodes, setApiDigitalizationCodes] = useState([]);
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editModalValidationError, setEditModalValidationError] = useState("");
  const [saving, setSaving] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  const [enableAllFieldsEdit, setEnableAllFieldsEdit] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    historyData: [],
    hasHistory: false,
  });
  const [editModalData, setEditModalData] = useState({
    fieldKey: "",
    fieldLabel: "",
    currentValue: "",
    originalValue: "",
    confidenceLevel: 0,
    digitalizationCode: "",
    comment: "",
  });
  const [validationCounts, setValidationCounts] = useState({
    noOfFieldsToBeReviewed: 0,
    noOfFieldsReviewed: 0,
  });
  const classes = useStyles();

  // Helper function to get Certificate of Manufacture data from digitizedExtractedData
  const getCertificateOfManufactureFromExtractedData = () => {
    if (batchDetails?.digitizedExtractedData && Array.isArray(batchDetails.digitizedExtractedData)) {
      const comData = batchDetails.digitizedExtractedData.find(
        item => item.documentType === "CertificateOfManufacture"
      );
      const originalData = comData?.CoMJSONOriginal || null;
      
      // Add test data for testing needValidation functionality
      if (originalData) {
        return {
          ...originalData,
          number_of_containers: {
            ...originalData.number_of_containers,
            needValidation: true
          },
          container_type: {
            ...originalData.container_type,
            needValidation: true
          }
        };
      }
      
      return originalData;
    }
    return null;
  };

  // Helper function to check if comJSONEdited has data
  const hasComJSONEditedData = () => {
    if (batchDetails?.comJSONEdited && typeof batchDetails.comJSONEdited === 'object') {
      const keys = Object.keys(batchDetails.comJSONEdited);
      return keys.length > 0;
    }
    return false;
  };
 
  const calculateValidationCounts = (data) => {
    let noOfFieldsToBeReviewed = 0;
    let noOfFieldsReviewed = 0;
  
    // Check static fields (root-level fields in staticFieldMapping)
    Object.keys(staticFieldMapping).forEach((key) => {
      if (data[key]?.needValidation === true) {
        //console.log(`[calculateValidationCounts] Static field ${key} has needValidation: true`);
        noOfFieldsToBeReviewed++;
      } else if (
        data[key]?.needValidation === false &&
        (data[key]?.reasonCode || data[key]?.comment)
      ) {
        // console.log(`[calculateValidationCounts] Static field ${key} has needValidation: false, reasonCode: ${data[key]?.reasonCode}, comment: ${data[key]?.comment}`
        // );
        noOfFieldsReviewed++;
      }
    });
  
    // Check dynamic fields in material_information only
    (data.material_information || []).forEach((material, index) => {
      Object.keys(material).forEach((key) => {
        // Only process fields that are in dynamicFields
        const dynamicField = dynamicFields.find((df) => df.apiField === key);
        if (dynamicField) {
          if (material[key]?.needValidation === true) {
            //console.log(
            //  `[calculateValidationCounts] Dynamic field ${key} (material ${index}) has needValidation: true`
            //);
            noOfFieldsToBeReviewed++;
          } else if (
            material[key]?.needValidation === false &&
            (material[key]?.reasonCode || material[key]?.comment)
          ) {
            //console.log(
            //  `[calculateValidationCounts] Dynamic field ${key} (material ${index}) has needValidation: false, reasonCode: ${material[key]?.reasonCode}, comment: ${material[key]?.comment}`
            //);
            noOfFieldsReviewed++;
          }
        }
      });
    });
  
  
    return { noOfFieldsToBeReviewed, noOfFieldsReviewed };
  };

  useEffect(() => {
    let dataToUse = initialData || { material_information: [] };
    let originalDataToUse = initialData || { material_information: [] };
  
    // First priority: Check if comJSONEdited has data
    if (hasComJSONEditedData()) {
      dataToUse = batchDetails.comJSONEdited;
      setEditedData(batchDetails.comJSONEdited);
    }
  
    // Get original unedited data from digitizedExtractedData
    const extractedData = getCertificateOfManufactureFromExtractedData();
    if (extractedData) {
      originalDataToUse = extractedData;
    }
  
    setApiData(dataToUse);
    setOriginalData(originalDataToUse);
  
    if (!hasComJSONEditedData()) {
      setEditedData(dataToUse);
    }
  
    // Initialize validation counts from the actual data structure
    const currentData = hasComJSONEditedData() ? batchDetails.comJSONEdited : extractedData;
    if (currentData) {
      // Get counts directly from the data if available
      // const noOfFieldsToBeReviewed = currentData.noOfFieldsToBeReviewed || 0;
      // const noOfFieldsReviewed = currentData.noOfFieldsReviewed || 0;
      const counts =calculateValidationCounts(currentData);
      
      if (currentData) {
        const counts = calculateValidationCounts(currentData);
        ////console.log('Setting validation counts from data:', counts);
        setValidationCounts(counts);
      }
      
      // setValidationCounts({
      //   noOfFieldsToBeReviewed,
      //   noOfFieldsReviewed,
      // });
    }
  }, [initialData, batchDetails]);
  
  useEffect(() => {
    if (batchDetails && !showingOriginal) {
      if (hasComJSONEditedData()) {
        setApiData(batchDetails.comJSONEdited);
        setEditedData(batchDetails.comJSONEdited);
      }
      const extractedData = getCertificateOfManufactureFromExtractedData();
      if (extractedData) {
        setOriginalData(extractedData);
      }
      
      // Update validation counts from the actual data
      const currentData = hasComJSONEditedData() ? batchDetails.comJSONEdited : extractedData;
      if (currentData) {
        // const noOfFieldsToBeReviewed = currentData.noOfFieldsToBeReviewed || 0;
        // const noOfFieldsReviewed = currentData.noOfFieldsReviewed || 0;
        
        // //console.log('Updating validation counts from batchDetails:', { noOfFieldsToBeReviewed, noOfFieldsReviewed });
        const counts = calculateValidationCounts(currentData);
      ////console.log('Updating validation counts from batchDetails:', counts);
      setValidationCounts(counts);  
        // setValidationCounts({
        //   noOfFieldsToBeReviewed,
        //   noOfFieldsReviewed,
        // });
      }
    }
  }, [batchDetails?.comJSONEdited, batchDetails?.digitizedExtractedData]);

  // Digitalization code options
  //Fetch digitalization codes on component mount
  useEffect(() => {
    const fetchDigitalizationCodes = async () => {
      try {
        const response = await axios.get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/Admin/fetchDigitalizationCodes`
        );
       // //console.log('Digitalization Codes Response:', response.data);
        if (response.data.status && response.data.digitalizationCodesList) {
          // Filter only activated codes and map to the format needed for the dropdown
          const activatedCodes = response.data.digitalizationCodesList
            .filter(code => code.activated && !code.markForDelete)
            .map(code => ({
              code: code.digitalizationCode,
              description: code.digitalizationCodeDescription
            }));
          setApiDigitalizationCodes(activatedCodes);
          //console.log('Processed Digitalization Codes:', activatedCodes);
        }
      } catch (error) {
        console.error('Error fetching digitalization codes:', error);
      }
    };
    fetchDigitalizationCodes();
  }, []); // Empty dependency array means this runs once on mount/ Empty dependency array means this runs once on mount

  
 
  const staticFieldMapping = {
    batch_number: "CMO FG Batch #",
    manufacture_date: "Date of Manufacture",
    expiry_date: "Expiry Date",
    fill_before_date: "Fill Before Date",
    material_number: "CMO Product Code",
    product_name: "Sponsor Description",
    qty_produced: "Quantity Produced",
    total_weight: "Total Weight",
    uom: "UOM",
    number_of_containers: "Number of Containers",
    container_type: "Container Type",
  };

  // Dynamic field mapping for material information
const materialFieldMapping = {
  api_code: "CMO Material Number",
  consumed_bms_batch: "Consumed Sponsor Batch",
  consumed_patheon_batch: "Consumed Patheon Batch",
  supplier: "Supplier",
  actual_consumed_batch_quantity: "Actual Consumed Batch Quantity",
  consumed_material_uom: "Consumed Material UOM",
};
const mandatoryDynamicFields = [
  'api_code', // CMO Material Number
  // 'consumed_bms_batch', // Consumed BMS Batch
  // 'consumed_patheon_batch', // Consumed Patheon Batch
  // 'actual_consumed_batch_quantity', // Actual Consumed Batch Quantity
];



// Generate dynamic fields based on material_information array
const generateDynamicFields = () => {
  const materials = apiData.material_information || [];
  const dynamicFields = [];

  const excludedFields = ['supplier']; // base field names to exclude

  materials.forEach((material, index) => {
    const materialLabel = `Material ${String.fromCharCode(65 + index)}`; // A, B, etc.

    Object.keys(material).forEach((fieldKey) => {
      const baseKey = fieldKey.replace(/_\d+$/, ''); // api_code_1 -> api_code

      // Skip excluded fields like 'supplier'
      if (excludedFields.includes(baseKey)) return;

      if (materialFieldMapping[baseKey]) {
        dynamicFields.push({
          apiField: fieldKey,
          displayLabel: `${materialFieldMapping[baseKey]}`,
          materialIndex: index,
          originalField: baseKey,
        });
      }
    });
  });

  return dynamicFields;
};
// const generateDynamicFields = () => {
//   const materials = apiData.material_information || [];
//   const dynamicFields = [];

//   const excludedFields = [];

//   materials.forEach((material, index) => {
//     const materialLabel = `Material ${String.fromCharCode(65 + index)}`;

//     Object.keys(material).forEach((fieldKey) => {
//       const baseKey = fieldKey.replace(/_\d+$/, '');
//       if (excludedFields.includes(baseKey)) return;

//       if (materialFieldMapping[baseKey]) {
//         // Generate custom label based on baseKey and index
//         let displayLabel;
//         switch (baseKey) {
//           case 'api_code':
//             displayLabel =  "CMO Material Batch Number";
//             break;
//           case 'consumed_bms_batch':
//             displayLabel = "Consumed Material Batch Number";
//             break;
//           case 'consumed_patheon_batch':
//             displayLabel = "Consumed Material patheon Batch Number";
//             break;
//           case 'actual_consumed_batch_quantity':
//             displayLabel = "Actual Component Quantity Consumed";
//             break;
//           case 'consumed_material_uom':
//             displayLabel = "UoM";
//             break;
//           case 'supplier_':
//             displayLabel = "BMS Material Number";
//             break;
//           default:
//             displayLabel = materialFieldMapping[baseKey];
//         }

//         dynamicFields.push({
//           apiField: fieldKey,
//           displayLabel: displayLabel,
//           materialIndex: index,
//           originalField: baseKey,
//         });
//       }
//     });
//   });

//   return dynamicFields;
// };

// Define fields array by combining static and dynamic field keys

const dynamicFields = generateDynamicFields();

  
  // };
  const handleOpenEditModal = (fieldKey, fieldLabel) => {
    const currentValue = getValueForField(fieldKey);
    const confidence = getConfidenceForField(fieldKey);
    
    // Check if the field was previously edited and retrieve reasonCode/comment
    let wasPreviouslyEdited = false;
    let reasonCode = "";
    let comment = "";
    const currentComData = batchDetails?.comJSONEdited || getCertificateOfManufactureFromExtractedData();
    
    //console.log(`[handleOpenEditModal] fieldKey: ${fieldKey}, currentComData:`, currentComData);
  
    // Check root-level (flattened) fields
    if (currentComData?.[fieldKey]?.reasonCode || currentComData?.[fieldKey]?.comment) {
      //console.log(`[handleOpenEditModal] Field ${fieldKey} has reasonCode: ${currentComData[fieldKey].reasonCode}, comment: ${currentComData[fieldKey].comment}`);
      wasPreviouslyEdited = true;
      reasonCode = currentComData[fieldKey].reasonCode || "";
      comment = currentComData[fieldKey].comment || "";
    } else if (currentComData?.material_information) {
      // Check dynamic fields in material_information
      const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
      if (dynamicField) {
        const { materialIndex } = dynamicField;
        const material = currentComData.material_information?.[materialIndex];
        if (material?.[fieldKey]?.reasonCode || material?.[fieldKey]?.comment) {
          //console.log(`[handleOpenEditModal] Dynamic field ${fieldKey} (material ${materialIndex}) has reasonCode: ${material[fieldKey].reasonCode}, comment: ${material[fieldKey].comment}`);
          wasPreviouslyEdited = true;
          reasonCode = material[fieldKey].reasonCode || "";
          comment = material[fieldKey].comment || "";
        } else {
         // console.log(`[handleOpenEditModal] Dynamic field ${fieldKey} (material ${materialIndex}) not previously edited`);
        }
      } else {
        //console.log(`[handleOpenEditModal] No dynamic field found for ${fieldKey}`);
      }
    }
  
    // Fallback to editedData if comJSONEdited lacks reasonCode/comment
    if (!wasPreviouslyEdited) {
      if (editedData?.[fieldKey]?.reasonCode || editedData?.[fieldKey]?.comment) {
        ////console.log(`[handleOpenEditModal] Field ${fieldKey} found edited in editedData: reasonCode: ${editedData[fieldKey].reasonCode}, comment: ${editedData[fieldKey].comment}`);
        wasPreviouslyEdited = true;
        reasonCode = editedData[fieldKey].reasonCode || "";
        comment = editedData[fieldKey].comment || "";
      } else if (editedData?.material_information) {
        const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
        if (dynamicField) {
          const { materialIndex } = dynamicField;
          const material = editedData.material_information?.[materialIndex];
          if (material?.[fieldKey]?.reasonCode || material?.[fieldKey]?.comment) {
            //console.log(`[handleOpenEditModal] Dynamic field ${fieldKey} (material ${materialIndex}) found edited in editedData: reasonCode: ${material[fieldKey].reasonCode}, comment: ${material[fieldKey].comment}`);
            wasPreviouslyEdited = true;
            reasonCode = material[fieldKey].reasonCode || "";
            comment = material[fieldKey].comment || "";
          }
        }
      }
    }
  
    //console.log(`[handleOpenEditModal] Setting wasPreviouslyEdited: ${wasPreviouslyEdited}, digitalizationCode: ${reasonCode}, comment: ${comment}`);
  
    setEditModalData({
      fieldKey,
      fieldLabel,
      currentValue,
      originalValue: currentValue,
      confidenceLevel: confidence,
      digitalizationCode: reasonCode,
      comment: comment,
      wasPreviouslyEdited,
    });
    setEditModalValidationError("");
    setOpenEditModal(true);
  };


  const fields = [
    ...Object.keys(staticFieldMapping),
    ...dynamicFields.map(df => df.apiField)
  ];


const handleSaveFieldEdit = async () => {
  //console.log('=== handleSaveFieldEdit started ===');
  //console.log('editModalData:', editModalData);
  //console.log('batchDetails:', batchDetails);
  const error = validateField(editModalData.fieldKey, editModalData.currentValue);
  if (error) {
    setEditModalValidationError(error);
    return;
  }
  // Validation: if no digitalization code is selected, comment is mandatory
  if (!editModalData.digitalizationCode && !editModalData.comment.trim()) {
    setEditModalValidationError("If reason code is not entered, comment field is mandatory");
    return;
  }

  // Clear validation error if validation passes
  setEditModalValidationError("");

  try {
    setSaving(true);
    //console.log('Setting saving to true...');

    // Update the form value
    let newData = { ...apiData };
    const dynamicField = dynamicFields.find((df) => df.apiField === editModalData.fieldKey);

    if (dynamicField) {
      const { materialIndex } = dynamicField;
      const newMaterials = [...(apiData.material_information || [])];
      newMaterials[materialIndex] = {
        ...(newMaterials[materialIndex] || {}),
        [editModalData.fieldKey]: {
          ...(newMaterials[materialIndex]?.[editModalData.fieldKey] || {}),
          value: editModalData.currentValue,
          needValidation: false,
          reasonCode: editModalData.digitalizationCode,
          comment: editModalData.comment,
        },
      };
      newData = { ...apiData, material_information: newMaterials };
      // // Update flattened field
      // newData[editModalData.fieldKey] = {
      //   ...(newData[editModalData.fieldKey] || {}),
      //   value: editModalData.currentValue,
      //   needValidation: false,
      //   reasonCode: editModalData.digitalizationCode,
      //   comment: editModalData.comment,
      // };
    } else {
      const currentFieldData = apiData[editModalData.fieldKey];
      newData = {
        ...apiData,
        [editModalData.fieldKey]: {
          ...(typeof currentFieldData === 'object' ? currentFieldData : {}),
          value: editModalData.currentValue,
          needValidation: false,
          reasonCode: editModalData.digitalizationCode,
          comment: editModalData.comment,
        },
    }
  }

    setApiData(newData);
    setEditedData(newData);

    // Get current Certificate of Manufacture data
    const currentComData = batchDetails?.comJSONEdited || getCertificateOfManufactureFromExtractedData();
    
    // Check if the field being edited had needValidation: true
    let wasFieldNeedingValidation = false;
    
    // Check in both root level and material_information array
    if (currentComData[editModalData.fieldKey] && currentComData[editModalData.fieldKey].needValidation === true) {
      wasFieldNeedingValidation = true;
    } else if (currentComData.material_information) {
      // Check in material_information array
      currentComData.material_information.forEach(material => {
        if (material[editModalData.fieldKey] && material[editModalData.fieldKey].needValidation === true) {
          wasFieldNeedingValidation = true;
        }
      });
    }

    

    const updatedKvpJson = {
      ...currentComData,
      // Include the entire material_information array from newData
      material_information: newData.material_information || [],
      // Only update static fields at the root level
      ...Object.keys(staticFieldMapping).reduce((acc, fieldKey) => ({
        ...acc,
        [fieldKey]: editModalData.fieldKey === fieldKey ? {
          value: editModalData.currentValue,
          confidence: getConfidenceForField(fieldKey),
          needValidation: false,
          reasonCode: editModalData.digitalizationCode,
          comment: editModalData.comment,
        } : {
          value: getValueForField(fieldKey),
          confidence: getConfidenceForField(fieldKey),
          needValidation: currentComData[fieldKey]?.needValidation ?? false,
          ...(currentComData[fieldKey]?.reasonCode && { reasonCode: currentComData[fieldKey].reasonCode }),
          ...(currentComData[fieldKey]?.comment && { comment: currentComData[fieldKey].comment }),
        },
      }), {}),
      document_type: currentComData.document_type || "CertificateOfManufacture",
      folder_name: currentComData.folder_name || "Patheon",
      site_name: currentComData.site_name || "Toronto",
      filename: currentComData.filename || digitizedData?.processedFileName,
      s3_location: currentComData.s3_location,
      ...calculateValidationCounts(newData), // Recalculate counts based on updated data
    };
    

    

   

    // Prepare API request payload
    const requestPayload = {
      schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
      comJSONEdited: updatedKvpJson,
      poNumber: poNumber,
      batchNumber: batchNumber,
      cdmoOrgID: batchDetails?.vendorMosymphonyID,
      file_type: digitizedData?.documentType || "CertificateOfManufacture",
    };

    //console.log('API Request Payload:', JSON.stringify(requestPayload, null, 2));

    // Make API call
    const response = await axios.post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      }
    );

    //console.log('API Response:', response.data);

    if (response.data.success) {
      //console.log('Certificate of Manufacture field saved successfully');
      
      // Update local validation counts immediately
      setValidationCounts(
        calculateValidationCounts(newData)
      );
      
      const refreshData = {
        schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
      };
      dispatch(fetchDSBatchDetails(refreshData));
      setOpenEditModal(false);
    } else {
      console.error('Failed to save:', response.data.message);
    }
  } catch (error) {
    console.error('Error saving Certificate of Manufacture field:', error);
  } finally {
    setSaving(false);
  }
};

  
const validateField = (fieldKey, value) => {
  const validations = {
    batch_number: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    manufacture_date: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    expiry_date: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    material_number: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+$/.test(val)) return "Must be numeric";
        return null;
      },
    },
    product_name: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    qty_produced: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+(\.\d+)?$/.test(val)) return "Must be a valid number";
        return null;
      },
    },
    total_weight: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+(\.\d+)?$/.test(val)) return "Must be a valid number";
        return null;
      },
    },
    uom: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    number_of_containers: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+$/.test(val)) return "Must be numeric";
        return null;
      },
    },
    container_type: {
      validate: (val) => {
        // Allow empty values
        return null;
      },
    },
    api_code: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+$/.test(val)) return "Must be numeric";
        return null;
      },
    },
    consumed_bms_batch: {
      validate: (val) => {
        if (!val || val.trim() === '') return null; // Optional
        return null;
      },
    },
    consumed_patheon_batch: {
      validate: (val) => {
        if (!val || val.trim() === '') return null; // Optional
        return null;
      },
    },
    supplier: {
      validate: (val) => {
        if (!val || val.trim() === '') return null; // Optional
        return null;
      },
    },
    actual_consumed_batch_quantity: {
      validate: (val) => {
        // Allow empty values
        if (val && val.trim() !== '' && !/^\d+(\.\d+)?$/.test(val)) return "Must be a valid number";
        return null;
      },
    },
    consumed_material_uom: {
      validate: (val) => {
        if (!val || val.trim() === '') return null; // Optional
        return null;
      },
    },
  };

  // Map dynamic field to its base validation key
  const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
  const validationKey = dynamicField ? dynamicField.originalField : fieldKey;
  const fieldValidation = validations[validationKey];
  return fieldValidation ? fieldValidation.validate(value) : null;
};
  const validateAllFields = () => {
    const errors = {};
    fields.forEach(fieldKey => {
      const error = validateField(fieldKey, getValueForField(fieldKey));
      if (error) {
        errors[fieldKey] = error;
      }
    });

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getValueForField = (fieldKey) => {
    // Handle static fields
    if (staticFieldMapping[fieldKey]) {
      const fieldData = apiData[fieldKey];
      if (fieldData && typeof fieldData === 'object' && fieldData.value !== undefined) {
        return fieldData.value || '';
      }
      return fieldData || '';
    }
  // Handle dynamic fields - check only material_information
  const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
  if (dynamicField) {
    const { materialIndex } = dynamicField;
    const material = apiData.material_information?.[materialIndex];
    if (material && material[fieldKey] && material[fieldKey].value !== undefined) {
      //console.log(
        //`[getValueForField] Dynamic field ${fieldKey} (material ${materialIndex}): value=${material[fieldKey].value}`
      //);
      return material[fieldKey].value || '';
    }
  }

  //console.log(`[getValueForField] Field ${fieldKey} not found`);
  return '';
    
  };

  // Helper function to check if field should show info icon for edited data with reason/comment
  const shouldShowInfoIcon = (fieldKey) => {
    // Don't show info icon when showing original data
    if (showingOriginal) return false;
    
    // Check at root level first (flattened structure)
    //let fieldData = batchDetails?.comJSONEdited?.[fieldKey];
    if (staticFieldMapping[fieldKey]) {
      const fieldData = batchDetails?.comJSONEdited?.[fieldKey];
      if (!fieldData || typeof fieldData !== 'object') return false;
      return fieldData.needValidation === false && (fieldData.reasonCode || fieldData.comment);
    }
    // Check dynamic fields in material_information
  const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
  if (dynamicField) {
    const { materialIndex } = dynamicField;
    const material = batchDetails?.comJSONEdited?.material_information?.[materialIndex];
    const fieldData = material?.[fieldKey];
    if (!fieldData || typeof fieldData !== 'object') return false;
    //console.log(
     // `[shouldShowInfoIcon] Dynamic field ${fieldKey} (material ${materialIndex}): needValidation=${fieldData.needValidation}, reasonCode=${fieldData.reasonCode}, comment=${fieldData.comment}`
    //);
    return fieldData.needValidation === false && (fieldData.reasonCode || fieldData.comment);
  }

  return false;
    
  };

  // Helper function to check if field has needValidation: true
  const shouldShowEditForValidation = (fieldKey) => {
    // Don't show edit icon when showing original data
    if (showingOriginal) return false;
    
    // Check static fields
    if (staticFieldMapping[fieldKey]) {
      // Check edited data first, then fall back to original data
      const currentComData = batchDetails?.comJSONEdited || getCertificateOfManufactureFromExtractedData();
      const fieldData = currentComData?.[fieldKey];
      if (!fieldData || typeof fieldData !== 'object') return false;
      //console.log(`[shouldShowEditForValidation] Static field ${fieldKey}: needValidation=${fieldData.needValidation}`);
      return fieldData.needValidation === true;
    }

    // Check dynamic fields in material_information
    const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
    if (dynamicField) {
      const { materialIndex } = dynamicField;
      const currentComData = batchDetails?.comJSONEdited || getCertificateOfManufactureFromExtractedData();
      const material = currentComData?.material_information?.[materialIndex];
      const fieldData = material?.[fieldKey];
      if (!fieldData || typeof fieldData !== 'object') return false;
      //console.log(
       // `[shouldShowEditForValidation] Dynamic field ${fieldKey} (material ${materialIndex}): needValidation=${fieldData.needValidation}`
      //);
      return fieldData.needValidation === true;
    }

    return false;
    
  };

  // Helper function to check if editing should be disabled based on needValidation flags
  const isEditingDisabled = () => {
    // Get current Certificate of Manufacture data (edited or original)
    const currentCoMData = batchDetails?.comJSONEdited || getCertificateOfManufactureFromExtractedData();
    if (!currentCoMData) return true;
    
    // Check if any static field has needValidation: true
    const hasStaticFieldsNeedingValidation = staticFieldMapping && Object.keys(staticFieldMapping).some(fieldKey => {
      const fieldData = currentCoMData[fieldKey];
      return fieldData && typeof fieldData === 'object' && fieldData.needValidation === true;
    });
    
    // Check if any dynamic field has needValidation: true
    const hasDynamicFieldsNeedingValidation = dynamicFields.some(dynamicField => {
      const { materialIndex, apiField } = dynamicField;
      const material = currentCoMData?.material_information?.[materialIndex];
      const fieldData = material?.[apiField];
      return fieldData && typeof fieldData === 'object' && fieldData.needValidation === true;
    });
    
    // Enable editing if any field has needValidation: true
    return !(hasStaticFieldsNeedingValidation || hasDynamicFieldsNeedingValidation);
  };

  // Function to fetch field history from API
  const fetchFieldHistory = async (fieldKey, fieldLabel) => {
    try {
      setIsFetchingHistory(true);
      
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/fetchExtractedDataHistory`,
        {
            schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
            dataFieldName: fieldKey,
            documentType: "CertificateOfManufacture"
          }
      );

      if (response.data.status && response.data.fieldDataHistory && response.data.fieldDataHistory.length > 0) {
        const historyData = response.data.fieldDataHistory.map(record => ({
          timestamp: record.lastUpdatedDate ? new Date(record.lastUpdatedDate).toLocaleString() : new Date().toLocaleString(),
          before: record.beforeValue || 'N/A',
          after: record.afterValue || 'N/A',
          updatedBy: record.lastUpdatedBy || 'System'
        }));

        setModalData({
          field: fieldLabel,
          historyData: historyData,
          hasHistory: historyData.length > 0,
        });
      } else {
        setModalData({
          field: fieldLabel,
          historyData: [],
          hasHistory: false,
        });
      }
      
      setOpenModal(true);
    } catch (error) {
      console.error('Error fetching field history:', error);
      setModalData({
        field: fieldLabel,
        historyData: [],
        hasHistory: false,
      });
      setOpenModal(true);
    } finally {
      setIsFetchingHistory(false);
    }
  };

  const getConfidenceForField = (fieldKey) => {
    const parseConfidence = (conf) => conf === null ? null : parseFloat(conf);
  // Static field check
  if (staticFieldMapping[fieldKey]) {
    const fieldData = apiData[fieldKey];
    const conf = fieldData?.confidence;
    ////console.log(`[getConfidenceForField] Static field ${fieldKey}: confidence=${conf}`);
    return conf !== undefined ? parseConfidence(conf) : null;
  }

  // Dynamic field check - check only material_information
  const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
  if (dynamicField) {
    const { materialIndex } = dynamicField;
    const material = apiData.material_information?.[materialIndex];
    const conf = material?.[fieldKey]?.confidence;
    return conf !== undefined ? parseConfidence(conf) : null;
  }

  //console.log(`[getConfidenceForField] Field ${fieldKey} not found`);
  return null;
    
  };
  
  const getLevelColor = (level) => {
    if (level === null || level === undefined) return "#cccccc"; // Gray for N/A
    if (level < 80) return "red";
    if (level <= 90) return "orange";
    return "green";
  };

  const getConfidenceDisplay = (fieldKey) => {
    const confidence = getConfidenceForField(fieldKey);
    return confidence !== null ? Math.round(confidence) : "N/A";
  };

  const handleInputChange = (apiField, value) => {
    let newData = { ...apiData };
  
    // Handle static fields
    if (staticFieldMapping[apiField]) {
      const currentFieldData = apiData[apiField];
      newData = {
        ...apiData,
        [apiField]: typeof currentFieldData === 'object' ? 
          { ...currentFieldData, value: value } : 
          value,
      };
    } else {
      // Handle dynamic fields - update both flattened and nested structures
      const dynamicField = dynamicFields.find((df) => df.apiField === apiField);
      if (dynamicField) {
        // Update flattened structure at root level
        if (apiData[apiField]) {
          const currentFieldData = apiData[apiField];
          newData[apiField] = typeof currentFieldData === 'object' ? 
            { ...currentFieldData, value: value } : 
            value;
        }
        
        // Update nested structure in material_information array
        const { materialIndex } = dynamicField;
        const newMaterials = [...(apiData.material_information || [])];
        if (newMaterials[materialIndex]) {
          newMaterials[materialIndex] = {
            ...(newMaterials[materialIndex] || {}),
            [apiField]: {
              ...(newMaterials[materialIndex]?.[apiField] || {}),
              value: value,
            },
          };
          newData = { ...newData, material_information: newMaterials };
        }
      }
    }
  
    setApiData(newData);
    if (!showingOriginal) {
      setEditedData(newData);
    }
  
    // Validate the field and update errors
    const error = validateField(apiField, value);
    setValidationErrors((prev) => ({
      ...prev,
      [apiField]: error,
    }));
  };

  

  const isFieldChanged = (apiField) => {
    const currentValue = getValueForField(apiField);
    const originalValue = originalData[apiField];
    const originalValueToCompare = originalValue && typeof originalValue === 'object' && originalValue.value !== undefined
      ? originalValue.value 
      : originalValue;
    
    return currentValue !== originalValueToCompare;
  };

  return (
    <>
      {/* Loading overlay when fetching field history */}
      {isFetchingHistory && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box 
            style={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 8,
              textAlign: 'center',
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Loading field history...</Typography>
          </Box>
        </Box>
      )}

      {/* Loading overlay when refreshing data */}
      {isRefreshing && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box 
            style={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 8,
              textAlign: 'center',
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Refreshing data...</Typography>
          </Box>
        </Box>
      )}
      
      <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
              onClick={onClose}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">
              Digitized Certificate of Manufacture
            </Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        {/* Actions*/}
        <Grid item container alignItems="center" spacing={2}>
          <Grid item xs={6}>
            <Grid item style={{display: "flex", alignItems: "center"}} spacing={2}>
              <Typography
                variant="h6"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  marginRight: "8px",
                  flexGrow: 1, // Pushes the button group to the right
                }}
              >
                Certificate of Manufacture Data
              </Typography>
              <Box display="flex" gap={1} spacing={2} style={{marginLeft:"70px"}}>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (showingOriginal) {
                      // Switch back to edited version (editable)
                      setApiData(editedData);
                      setShowingOriginal(false);
                    } else {
                      // Switch to original version (non-editable)
                      setApiData(originalData);
                      setShowingOriginal(true);
                    }
                  }}
                  style={{ marginRight: "8px", minWidth: 20, textAlign: "center", size: "20px", textTransform: "none", backgroundColor:"grey",color: "white", }}
                >
                  {showingOriginal ? "Show Edited Version" : "Show Unedited Version"}
                </Button>
              </Box>
            </Grid>
            {/* Validation Counts Display */}
            {/* <Box mt={1}>
              <Typography variant="body2" color="textSecondary">
                Fields to be reviewed: {validationCounts.noOfFieldsToBeReviewed} | 
                Fields reviewed: {validationCounts.noOfFieldsReviewed}
              </Typography>
            </Box> */}
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
          <Paper
  elevation={2}
  style={{
    height: "calc(100vh - 200px)",
    padding: 16,
    overflowY: "auto",
  }}
>
  {/* Static Fields */}
  {Object.keys(staticFieldMapping).map((apiField, index) => {
    const displayLabel = staticFieldMapping[apiField];

    return (
      <Grid
        container
        key={index}
        alignItems="center"
        spacing={2}
        className={classes.formField}
      >
        <Grid item xs={4}>
          <Box display="flex" alignItems="center">
            <Typography
              style={{
                paddingRight: 16,
                fontWeight: 500,
              }}
            >
              {displayLabel}
              {![
                "CMO Product Code",
                "Sponsor Description",
                "Fill Before Date",
                "Quantity Produced",
            
              ].includes(displayLabel) && (
                <span className={classes.requiredStar}>*</span>
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={8}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box style={{ width: showingOriginal ? "calc(100% - 60px)" : "calc(100% - 40px)" }}>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                value={getValueForField(apiField)}
                placeholder={`Enter ${displayLabel}`}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box display="flex" alignItems="center" pl={1}>
                        <Box style={{ width: 1, height: 39, backgroundColor: "#ccc", marginRight: 3 }} />
                        {shouldShowInfoIcon(apiField) && !showingOriginal ? (
                          <Box
                            onClick={() => fetchFieldHistory(apiField, displayLabel)}
                            style={{
                              backgroundColor: "#777",
                              color: "white",
                              borderRadius: 4,
                              padding: "2px 8px",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              minWidth: 24,
                              textAlign: "center",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Info fontSize="small" />
                          </Box>
                        ) : (
                          <Box style={{
                            backgroundColor: getLevelColor(getConfidenceForField(apiField)),
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                          }}>
                            {getConfidenceDisplay(apiField)}
                          </Box>
                        )}
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box style={{ width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {(enableAllFieldsEdit || shouldShowEditForValidation(apiField)) && !shouldShowInfoIcon(apiField) && !showingOriginal && !isEditingDisabled() ? (
                <Box
                  onClick={() => handleOpenEditModal(apiField, displayLabel)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Edit fontSize="small" style={{ color: "#EC6535" }} />
                </Box>
              ) : null}
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  })}

  {/* Dynamic Material Fields */}
  {(apiData.material_information || []).map((material, index) => {
    const materialLabel = `Material ${String.fromCharCode(65 + index)}`;
    return (
      <Box key={`material_${index}`} mt={2}>
        <Typography variant="h6" className={classes.sectionTitle}>
          {materialLabel}
        </Typography>
        {Object.keys(material).map((fieldKey, fieldIndex) => {
          const dynamicField = dynamicFields.find((df) => df.apiField === fieldKey);
          if (!dynamicField) return null;
          const displayLabel = dynamicField.displayLabel;
          const isMandatory = mandatoryDynamicFields.includes(dynamicField.originalField);
          return (
            <Grid
              container
              key={`${fieldKey}_${fieldIndex}`}
              alignItems="center"
              spacing={2}
              className={classes.formField}
            >
              <Grid item xs={4}>
                <Box display="flex" alignItems="center">
                  <Typography
                    style={{
                      paddingRight: 16,
                      fontWeight: 500,
                    }}
                  >
                    {displayLabel}
                    {isMandatory && <span className={classes.requiredStar}>*</span>}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box style={{ width: showingOriginal ? "calc(100% - 60px)" : "calc(100% - 40px)" }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={getValueForField(fieldKey)}
                      placeholder={`Enter ${displayLabel}`}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box display="flex" alignItems="center" pl={1}>
                              <Box style={{ width: 1, height: 39, backgroundColor: "#ccc", marginRight: 3 }} />
                              {shouldShowInfoIcon(fieldKey) && !showingOriginal ? (
                                <Box
                                  onClick={() => fetchFieldHistory(fieldKey, displayLabel)}
                                  style={{
                                    backgroundColor: "#777",
                                    color: "white",
                                    borderRadius: 4,
                                    padding: "2px 8px",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    minWidth: 24,
                                    textAlign: "center",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Info fontSize="small" />
                                </Box>
                              ) : (
                                <Box style={{
                                  backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                                  color: "white",
                                  borderRadius: 4,
                                  padding: "2px 8px",
                                  fontSize: "0.75rem",
                                  fontWeight: 600,
                                  minWidth: 24,
                                  textAlign: "center",
                                }}>
                                  {getConfidenceDisplay(fieldKey)}
                                </Box>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box style={{ width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {(enableAllFieldsEdit || shouldShowEditForValidation(fieldKey)) && !shouldShowInfoIcon(fieldKey) && !showingOriginal && !isEditingDisabled() ? (
                      <Box
                        onClick={() => handleOpenEditModal(fieldKey, displayLabel)}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Edit fontSize="small" style={{ color: "#EC6535" }} />
                      </Box>
                    ) : null}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          );
        })}
      </Box>
    );
  })}

<Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "73px" }} />
                {(() => {
                  // Get dynamic confidence levels from batch details
                  const confidenceLevels = batchDetails?.confidenceLevels;
                  const lowConfidenceLimit = confidenceLevels?.lowConfidenceLimit || 80;
                  const highConfidenceLimit = confidenceLevels?.highConfidenceLimit || 90;
                  
                  return (
                    <>
                      <Box
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                        }}
                      >
                        &gt; {highConfidenceLimit}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "orange",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 50,
                          marginLeft: 16,
                        }}
                      >
                        {confidenceLevels?.mediumConfidenceLimitMinValue} - {confidenceLevels?.mediumConfidenceLimitMaxValue}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                          marginLeft: 16,
                        }}
                      >
                        &lt; {lowConfidenceLimit}
                      </Box>
                    </>
                  );
                })()}
              </Box>
  {/* Edit All Fields Option */}
  {!showingOriginal && validationCounts.noOfFieldsToBeReviewed > 0 && (
    <Grid item xs={12}>
      <Box
        style={{
          border: "1px solid #ddd",
          padding: "12px",
          borderRadius: "4px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={enableAllFieldsEdit}
              onChange={(e) => setEnableAllFieldsEdit(e.target.checked)}
              color="primary"
              disabled={isEditingDisabled()}
            />
          }
          label="Apply edit feature to all the fields"
        />
        <Typography
          variant="body2"
          style={{
            fontStyle: "italic",
            color: "#666",
            marginTop: "4px",
          }}
        >
          Note - This will enable editing of the high confidence level fields, highlighted in green colors.
        </Typography>
      </Box>
    </Grid>
  )}
</Paper>
          </Grid>

          {/* Right side: PDF view placeholder */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {schrockenCustomFileID ? (
                <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
              ) : (
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                  <Typography>PDF not available</Typography>
              </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Box style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table>
              <TableHead
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableRow
                  style={{ border: "1px solid grey", backgroundColor: "#7777" }}
                >
                  <TableCell>
                    <b>Timestamp</b>
                  </TableCell>
                  <TableCell>
                    <b>Before Value</b>
                  </TableCell>
                  <TableCell>
                    <b>After Value</b>
                  </TableCell>
                  <TableCell>
                    <b>Updated By</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ border: "1px solid grey" }}>
                {modalData.hasHistory ? (
                  modalData.historyData.map((record, index) => (
                    <TableRow key={index}>
                      <TableCell>{record.timestamp}</TableCell>
                      <TableCell>{record.before}</TableCell>
                      <TableCell>{record.after}</TableCell>
                      <TableCell>{record.updatedBy}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                      No history found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
              style={{borderRadius: 30}}
              endIcon={<ArrowForwardIos style={{ fontSize: 15 }} />}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Field Modal */}
      <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">
              Edit {editModalData.fieldLabel} for PO {poNumber || ''}
            </Typography>
            <Button onClick={() => setOpenEditModal(false)} style={{ minWidth: 'auto' }}>
              ✕
            </Button>
          </Box>

          <Grid container spacing={3}>
            {/* <Grid item xs={6}>
              <Typography variant="body2" gutterBottom>
                {editModalData.fieldLabel}
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                value={editModalData.currentValue}
                onChange={(e) => setEditModalData(prev => ({ ...prev, currentValue: e.target.value }))}
                InputProps={{
                  endAdornment: (editModalData.confidenceLevel !== null && editModalData.confidenceLevel > 90) ? null : (
                    <InputAdornment position="end">
                      <Box
                        onClick={() => {
                          if (editModalData.currentValue === editModalData.originalValue) {
                            setEditModalData(prev => ({ ...prev, digitalizationCode: "DG001" }))
                          }
                        }}
                        style={{
                          backgroundColor: editModalData.currentValue === editModalData.originalValue ? "green" : "#cccccc",
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                          cursor: editModalData.currentValue === editModalData.originalValue ? "pointer" : "not-allowed",
                          opacity: editModalData.currentValue === editModalData.originalValue ? 1 : 0.5,
                        }}
                      >
                        ✓
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid> */}
            <Grid item xs={6}>
  <Typography variant="body2" gutterBottom  style={{ fontWeight: 'bold' }}>
    {editModalData.fieldLabel}
  </Typography>
  <Box display="flex" alignItems="center">
    <TextField
      variant="outlined"
      fullWidth
      size="small"
      value={editModalData.currentValue}
      onChange={(e) =>
        setEditModalData((prev) => ({
          ...prev,
          currentValue: e.target.value,
        }))
      }
      onBlur={(e) => {
        const { value } = e.target;
        // Trim leading and trailing spaces for string values
        if (typeof value === "string" && value.trim() !== value) {
          setEditModalData((prev) => ({ ...prev, currentValue: value.trim() }));
        }
      }}
    />
    {((editModalData.confidenceLevel !== null && editModalData.confidenceLevel > 90) || shouldShowInfoIcon(editModalData.fieldKey)) ? null : (
      <Box
        onClick={() => {
          if (
            editModalData.currentValue === editModalData.originalValue
          ) {
            setEditModalData((prev) => ({
              ...prev,
              digitalizationCode: "DG001",
            }));
          }
        }}
        style={{
          backgroundColor:
            editModalData.currentValue === editModalData.originalValue
              ? "green"
              : "#cccccc",
          color: "white",
          borderRadius: 4,
          padding: "2px 8px",
          fontSize: "0.75rem",
          fontWeight: 600,
          minWidth: 24,
          textAlign: "center",
          cursor:
            editModalData.currentValue === editModalData.originalValue
              ? "pointer"
              : "not-allowed",
          opacity:
            editModalData.currentValue === editModalData.originalValue
              ? 1
              : 0.5,
          marginLeft: 8, // adds spacing between input and icon
        }}
      >
        ✓
      </Box>
    )}
  </Box>
</Grid>

            <Grid item xs={6}>
              <Typography variant="body2" gutterBottom  style={{ fontWeight: 'bold' }}>
                Confidence Level (%)
              </Typography>
              
                <Typography variant="body2">
                  {editModalData.confidenceLevel !== null ? Math.round(editModalData.confidenceLevel) : "N/A"}
                </Typography>
              
            </Grid>
            <Grid item xs={12}>
  <Typography variant="body2" gutterBottom>
    Digitalization Code / Description
  </Typography>
  <FormControl fullWidth variant="outlined" size="small">
    <Select
      value={editModalData.digitalizationCode}
      onChange={(e) => {
        setEditModalData(prev => ({ ...prev, digitalizationCode: e.target.value }));
        setEditModalValidationError(""); // Clear validation error when user selects a code
      }}
      displayEmpty
    >
      <MenuItem value="">
        <em>Select a digitalization code</em>
      </MenuItem>
      {apiDigitalizationCodes.length > 0 ? (
        apiDigitalizationCodes.map((code) => (
          <MenuItem key={code.code} value={code.code}>
            {code.code} / {code.description}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>
          <em>No digitalization codes available</em>
        </MenuItem>
      )}
    </Select>
  </FormControl>
</Grid>
            <Grid item xs={12}>
              <Typography variant="body2" gutterBottom style={{ fontWeight: 'bold' }}>
                Comment
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                placeholder="Enter text here"
                value={editModalData.comment}
                onChange={(e) => { 
                  if(e.target.value.length < 256){
                  setEditModalData(prev => ({ ...prev, comment: e.target.value }))
                  }
                }}
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    setEditModalData(prev => ({ ...prev, comment: value.trim() }));
                  }
                }}
                multiline
                rows={3}
              />
              <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
                Note - If reason code is not entered, comment field is mandatory
              </Typography>
              {editModalValidationError && (
                <Typography variant="caption" color="error" style={{ marginTop: 4, display: 'block' }}>
                  {editModalValidationError}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Button
                  variant="contained"
                  style={{ 
                    backgroundColor: "#f57c00", 
                    color: "white",
                    minWidth: 140,
                    textTransform: "none"
                  }}
                  onClick={handleSaveFieldEdit}
                  disabled={saving}
                  endIcon={saving ? <CircularProgress size={20} /> : <ArrowForwardIos style={{ fontSize: 15 }} />}
                >
                  {saving ? "Saving..." : "Save changes"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}


export default ManufactureCertificate;
